import { defineMessages } from "react-intl";

const messages = defineMessages({
  myProfile: { id: "profileSettings.myProfile" },
  profileSettings: { id: "profileSettings.profileSettings" },
});

export default messages;
